function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/legend-eau-surface");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/legend-eau-surface",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#4D88FF",
  points: "28 2 28 28 2 28 2 2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#80D5FF",
  points: "24 6 6 6 6 24 24 24"
})));

const SvgIco30EauSurface = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30EauSurface, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-eauSurface.c9f0ac2f.svg";
export { ForwardRef as ReactComponent };